import { fetchApi } from '@/config/axiosSetting.ts';
import { FileInformationEntryTabQuery } from '@/modules/FileDetail/queries/fileInformationEntryTab/fileInformationEntryTabQuery.type.ts';

export const fileInformationEntryTabQueryFunction = (
  id: string,
): Promise<FileInformationEntryTabQuery[]> =>
  fetchApi.get(`/my_files/${id}/file_information/entry_tabs/`);
